<template>
	<section
		class="features-tiles section center-content pt-0 mb-24 pb-24"
		:class="[
			topOuterDivider && 'has-top-divider',
			bottomOuterDivider && 'has-bottom-divider',
			hasBgColor && 'has-bg-color',
			invertColor && 'invert-color',
		]"
	>
		<div class="container mb-24 pb-24">
			<div
				class="features-tiles-inner section-inner pt-0"
				:class="[
					topDivider && 'has-top-divider',
					bottomDivider && 'has-bottom-divider',
				]"
			>
				<c-section-header
					:data="sectionHeader"
                    :data-reveal-offset="500"
					class="center-content reveal-from-top mb-24"
				>
					<c-image
						class="mb-24"
						:src="require('@/assets/images/features-split-icon.svg')"
						alt="Features split icon"
						:width="80"
						:height="80"
					/>
				</c-section-header>
				<div class="tiles-wrap mt-24 mb-24 pb-24" :class="[pushLeft && 'push-left']">
					<div class="tiles-item">
						<div class="tiles-item-inner">
							<div class="features-tiles-item-header">
								<div
									class="features-tiles-item-image mb-16 reveal-from-top"
									data-reveal-container=".tiles-item"
								>
									<c-image
										:src="require('@/assets/images/feature-tile-icon-03.svg')"
										alt="Feature tile icon 01"
										:width="72"
										:height="72"
									/>
								</div>
							</div>
							<div class="features-tiles-item-content">
								<h4
									class="mt-0 mb-8 reveal-from-top"
									data-reveal-container=".tiles-item"
									data-reveal-delay="100"
								>
									Novel Leads
								</h4>
								<p
									class="m-0 text-sm reveal-from-top"
									data-reveal-container=".tiles-item"
									data-reveal-delay="200"
								>
									Go directly to developers and skip navigating hoops to get
									users and discover new possibilities for your products.
								</p>
							</div>
						</div>
					</div>

					<div class="tiles-item">
						<div class="tiles-item-inner">
							<div class="features-tiles-item-header">
								<div
									class="features-tiles-item-image mb-16 reveal-from-top"
									data-reveal-container=".tiles-item"
									data-reveal-delay="100"
								>
									<c-image
										:src="require('@/assets/images/feature-tile-icon-05.svg')"
										alt="Feature tile icon 02"
										:width="72"
										:height="72"
									/>
								</div>
							</div>
							<div class="features-tiles-item-content">
								<h4
									class="mt-0 mb-8 reveal-from-top"
									data-reveal-container=".tiles-item"
									data-reveal-delay="200"
								>
									Source Information
								</h4>
								<p
									class="m-0 text-sm reveal-from-top"
									data-reveal-container=".tiles-item"
									data-reveal-delay="300"
								>
									Track down people familiar with specific open source
									technologies your business is already using.
								</p>
							</div>
						</div>
					</div>

					<div class="tiles-item">
						<div class="tiles-item-inner">
							<div class="features-tiles-item-header">
								<div
									class="features-tiles-item-image mb-16 reveal-from-top"
									data-reveal-container=".tiles-item"
									data-reveal-delay="200"
								>
									<c-image
										:src="require('@/assets/images/feature-tile-icon-01.svg')"
										alt="Feature tile icon 03"
										:width="72"
										:height="72"
									/>
								</div>
							</div>
							<div class="features-tiles-item-content">
								<h4
									class="mt-0 mb-8 reveal-from-top"
									data-reveal-container=".tiles-item"
									data-reveal-delay="300"
								>
									Rich Data
								</h4>
								<p
									class="m-0 text-sm reveal-from-top"
									data-reveal-container=".tiles-item"
									data-reveal-delay="400"
								>
									Discover relationships between users and their favorite open
									source products, technologies, and programming languages.
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import { SectionTilesProps } from "@/utils/SectionProps.js";
import CSectionHeader from "@/components/sections/partials/SectionHeader.vue";
import CImage from "@/components/elements/Image.vue";

export default {
	name: "CFeaturesTiles",
	components: {
		CSectionHeader,
		CImage,
	},
	mixins: [SectionTilesProps],
	data() {
		return {
			sectionHeader: {
				//title: "Find your best users",
                title: "The best users are right next door",
				paragraph:
					"Mine prospects from popular open source projects relevant to your industry and get in touch with highly qualified leads that already understand your offerings.",
			},
		};
	},
};
</script>